import { Box, Fab, Grid, IconButton, TableCell, tableCellClasses, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { showLoader } from '../../../Redux/Slices/loaderSlice';
import { useDispatch } from 'react-redux';
import { delete_contactUs, get_contactUs } from '../../../Redux/Actions/action';
import ErrorHandler from '../../../Utils/handler';
import { toast } from 'react-toastify';
import CustomPagination from '../../Common/CommonPagination';
import CommonTable from '../../Common/CommonTable';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import DataNotFound from '../../Common/DataNotFound';
import { styled } from "@mui/material/styles";
import CommonSearchField from '../../Common/CommonSearchField';
import SearchIcon from '@mui/icons-material/Search';

const headerList = ["No", "Name", "Mobile No", "Message", "Action"]
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme?.palette?.bgLightWhite?.main,
    fontSize: 14,
    // fontWeight: "bold",
    textAlign: "center", // Horizontally align content,
    lineHeight: '1.2rem',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: '10px 10px !important',
    textAlign: "center", // Horizontally align content
    borderBottom: "2px solid #d9d6f3",
  },
}));

function ContactUs() {
  // ---------- Hook -----------
  const dispatch = useDispatch()

  // --------------- State -------------
  const [data, setData] = useState({});
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [searchText, setSearchText] = useState("");
  const [isSearch, setIsSearch] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const _get_contactUs = async () => {
    dispatch(showLoader(true))
    let body = {
      type: "News-Events",
      page: page,
      limit: rowsPerPage,
      search: searchText
    }
    try {
      const result = await dispatch(get_contactUs(body));
      const error = ErrorHandler(result);
      if (error) {
        setData(result?.payload?.data);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false))
    }
  }

  const _delete_contactUs = async (id) => {
    dispatch(showLoader(true))
    try {
      const result = await dispatch(delete_contactUs({ id: id }));
      console.log(result, 'deletefaq')
      const error = ErrorHandler(result);
      if (error) {
        toast.success(result?.payload?.message);
        _get_contactUs()
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false))
    }
  }

  // ---------- useEffect ------------ 
  useEffect(() => {
    _get_contactUs()
  }, [page, rowsPerPage, searchText])

  return (
    <>
      <Grid container spacing={1} xs={12}>
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: '20px', fontWeight: 500 }}>Contact Us Request</Typography>
            {!isSearch &&
              <Fab sx={{
                width: '46px', height: '42px', boxShadow: 'none', minHeight: "30px", padding: 0, border: '1px solid rgba(34, 34, 34, 0.3)', borderRadius: '10px', backgroundColor: "transparent", color: "rgba(34, 34, 34, 0.3)",
              }} onClick={() => setIsSearch(true)}>
                <SearchIcon sx={{ fontSize: '24px' }} />
              </Fab>
            }
            {isSearch &&
              <CommonSearchField placeholder={"Search.."} tooltipList={['Name', "Mobile No", "Message"]} handleSearch={(e) => { setPage(1); setSearchText(e); }} />
            }
          </Box>
        </Grid>
        <Grid item xs={12}>
          <CommonTable
            headerList={headerList}
          >
            {data?.data?.length > 0 ? data?.data?.map((item, index) => (
              <TableRow key={item.id}>
                <StyledTableCell align="center">{(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}</StyledTableCell>
                <StyledTableCell align="center">{item?.fullName}</StyledTableCell>
                <StyledTableCell align="center">{item?.mobileNo}</StyledTableCell>
                <StyledTableCell align="center">{item?.message}</StyledTableCell>
                <StyledTableCell align="center">
                  <IconButton sx={{ padding: 0 }} onClick={() => { _delete_contactUs(item?._id) }} >
                    <DeleteIcon fontSize="small" color='error' />
                  </IconButton>
                </StyledTableCell>
              </TableRow>
            )) :
              (<TableRow>
                <StyledTableCell colSpan={8}>
                  <DataNotFound title={'No Records Found'} icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "3rem" }} />} elevation={0} />
                </StyledTableCell>
              </TableRow>)
            }
          </CommonTable>
          {data?.total > 0 &&
            <Grid item xs={12}>
              <CustomPagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                count={Math.ceil(data?.total / rowsPerPage)}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage} />

            </Grid>}
        </Grid>
      </Grid>
    </>
  )
}

export default ContactUs
